function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
}), React.createElement("path", {
  fill: "#102E8E",
  d: "M17.58 14.083l-7.486 4.894A2 2 0 017 17.303V6.939a2 2 0 013.18-1.615l7.485 5.47a2 2 0 01-.085 3.289z"
}));

var SvgIcPlay = function SvgIcPlay(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMxMDJFOEUiIGQ9Ik0xNy41OCAxNC4wODNsLTcuNDg2IDQuODk0QTIgMiAwIDAgMSA3IDE3LjMwM1Y2LjkzOWEyIDIgMCAwIDEgMy4xOC0xLjYxNWw3LjQ4NSA1LjQ3YTIgMiAwIDAgMS0uMDg1IDMuMjg5eiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIcPlay as ReactComponent };